export const SET_OVERVIEW_FILTER: string = "SET_OVERVIEW_FILTER";
export const SET_CREDIT_FILTER: string = "SET_CREDIT_FILTER";

export function setOverviewFilter(key: string): IAddKeyActionType {
    return { type: SET_OVERVIEW_FILTER, filterKey: key };
}

export function setCreditFilter(key: string): IAddKeyActionType {
    return { type: SET_CREDIT_FILTER, filterKey: key };
}

export interface IAddKeyActionType { 
    type: string, 
    filterKey: string 
}
